import { PayloadAction } from "@reduxjs/toolkit";
import {
  IApiResponse,
  IDownloadAllInprocessCheck,
  IDownloadCartonQRCodeBank,
  IDownloadExcelRequest,
  IDownloadInprocessCheck,
  IDownloadLocationListConfirmPeriodicCycleCountRequest,
  IDownloadLODeliveryProgressRequest,
  IDownloadLODocumentByIdRequest,
  IDownloadMaterialRequisitionDetailReportRequest,
  IDownloadMaterialRequisitionReportRequest,
  IDownloadPalletMasterDataRequest,
  IDownloadProductionPlanDetailRequest,
  IDownloadProductionPlanRequest,
  IDownloadProductMasterDataRequest,
  IDownloadQRCodeBankRequest,
  IDownloadRequestMaterialDetail,
  IDownloadReturnReport,
  IDownloadTrackingQRCodeRequest,
} from "model";
import { IErrorResponse } from "model/Common/IErrorResponse";
import { call, put, takeEvery } from "redux-saga/effects";
import { DownloadActions } from "redux/actions";
import { DownloadApiService } from "services";

function* downloadENUserGuide(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadENUserGuide,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadProductMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadProductMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadProductMasterData.failed(error));
  }
}
function* downloadVNUserGuide(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadVNUserGuide,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadProductMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadProductMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadProductMasterData.failed(error));
  }
}
function* downloadProductMasterData(
  action: PayloadAction<IDownloadProductMasterDataRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadProductMasterData,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadProductMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadProductMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadProductMasterData.failed(error));
  }
}

function* downloadWarehouseMasterData(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadWarehouseMasterData,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadWarehouseMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadWarehouseMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadWarehouseMasterData.failed(error));
  }
}

function* downloadZoneMasterData(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadZoneMasterData,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadZoneMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadZoneMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadZoneMasterData.failed(error));
  }
}

function* downloadZoneDetailMasterData(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadZoneDetailMasterData,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadZoneDetailMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadZoneDetailMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadZoneDetailMasterData.failed(error));
  }
}

function* downloadPalletMasterData(
  action: PayloadAction<IDownloadPalletMasterDataRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadPalletMasterData,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadPalletMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadPalletMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadPalletMasterData.failed(error));
  }
}

function* downloadCompanyMasterData(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadCompanyMasterData,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadCompanyMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadCompanyMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadCompanyMasterData.failed(error));
  }
}

function* downloadUserMasterData(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadUserMasterData,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadUserMasterData.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadUserMasterData.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadUserMasterData.failed(error));
  }
}

function* downloadProductionPlan(
  action: PayloadAction<IDownloadProductionPlanRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadProductionPlan,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadProductionPlan.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadProductionPlan.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadProductionPlan.failed(error));
  }
}

function* downloadProductionPlanForm(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadProductionPlanForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadProductionPlanForm.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadProductionPlanForm.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadProductionPlanForm.failed(error));
  }
}

function* downloadReceiveDocument(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadReceiveDocument,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadReceiveDocument.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadReceiveDocument.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadReceiveDocument.failed(error));
  }
}

function* downloadReceiveDocumentById(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadReceiveDocumentById,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadReceiveDocumentById.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadReceiveDocumentById.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadReceiveDocumentById.failed(error));
  }
}

function* downloadReceiveExportPalletLabel(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadReceiveExportPalletLabel,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadReceiveExportPalletLabel.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadReceiveExportPalletLabel.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadReceiveExportPalletLabel.failed(error));
  }
}

function* downloadReceiveForm(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadReceiveForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadReceiveForm.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadReceiveForm.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadReceiveForm.failed(error));
  }
}

function* downloadLODocument(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadLODocument,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadLODocument.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadLODocument.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadLODocument.failed(error));
  }
}

function* downloadLODocumentForm(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadLODocumentForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadLODocumentForm.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadLODocumentForm.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadLODocumentForm.failed(error));
  }
}

function* downloadLODocumentById(
  action: PayloadAction<IDownloadLODocumentByIdRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadLODocumentById,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadLODocumentById.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadLODocumentById.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadLODocumentById.failed(error));
  }
}

function* downloadLODeliveryProgress(
  action: PayloadAction<IDownloadLODeliveryProgressRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadLODeliveryProgress,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadLODeliveryProgress.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadLODeliveryProgress.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadLODeliveryProgress.failed(error));
  }
}

function* downloadAuditTrail(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadAuditTrail,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadAuditTrail.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadAuditTrail.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadAuditTrail.failed(error));
  }
}
function* downloadQRCodeTracking(
  action: PayloadAction<IDownloadTrackingQRCodeRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadQRCodeTracking,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadQRCodeTracking.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadQRCodeTracking.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadQRCodeTracking.failed(error));
  }
}

function* downloadQRCodeBankXlsx(
  action: PayloadAction<IDownloadQRCodeBankRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadQRCodeBankXlsx,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadQRCodeBankXlsx.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadQRCodeBankXlsx.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadQRCodeBankXlsx.failed(error));
  }
}

function* downloadQRCodeBankCsv(
  action: PayloadAction<IDownloadQRCodeBankRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadQRCodeBankCsv,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadQRCodeBankCsv.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadQRCodeBankCsv.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadQRCodeBankCsv.failed(error));
  }
}

function* downloadWarehouseReport(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadWarehouseReport,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadWarehouseReport.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadWarehouseReport.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadWarehouseReport.failed(error));
  }
}

function* downloadPackingReport(action: PayloadAction<IDownloadExcelRequest>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadPackingReport,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadPackingReport.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadPackingReport.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadPackingReport.failed(error));
  }
}

function* downloadForkliftPerformanceReport(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadForkliftPerformanceReport,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadForkliftPerformanceReport.success());
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadForkliftPerformanceReport.failed(error)
      );
    }
  } catch (error) {
    yield put(DownloadActions.downloadForkliftPerformanceReport.failed(error));
  }
}

function* downloadDeliveryHistoryReport(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadDeliveryHistoryReport,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadDeliveryHistoryReport.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadDeliveryHistoryReport.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadDeliveryHistoryReport.failed(error));
  }
}

function* downloadDeliveryHistoryForMarketingReport(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadDeliveryHistoryForMarketingReport,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        DownloadActions.downloadDeliveryHistoryForMarketingReport.success()
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadDeliveryHistoryForMarketingReport.failed(error)
      );
    }
  } catch (error) {
    yield put(
      DownloadActions.downloadDeliveryHistoryForMarketingReport.failed(error)
    );
  }
}

function* downloadInventoryComparisonForm(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadInventoryComparisonForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadInventoryComparisonForm.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadInventoryComparisonForm.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadInventoryComparisonForm.failed(error));
  }
}

function* downloadInventoryComparisonReport(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadInventoryComparisonReport,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadInventoryComparisonReport.success());
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadInventoryComparisonReport.failed(error)
      );
    }
  } catch (error) {
    yield put(DownloadActions.downloadInventoryComparisonReport.failed(error));
  }
}

function* downloadProductionPlanDetail(
  action: PayloadAction<IDownloadProductionPlanDetailRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadProductionPlanDetail,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadProductionPlanDetail.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadProductionPlanDetail.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadProductionPlanDetail.failed(error));
  }
}

function* downloadMaterialRequisitionForm(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadMaterialRequisitionForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadMaterialRequisitionForm.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadMaterialRequisitionForm.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadMaterialRequisitionForm.failed(error));
  }
}

function* downloadMaterialMovementForm(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadMaterialMovementForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadMaterialMovementForm.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadMaterialMovementForm.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadMaterialMovementForm.failed(error));
  }
}

function* downloadPackagingMovementForm(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadPackagingMovementForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadPackagingMovementForm.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadPackagingMovementForm.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadPackagingMovementForm.failed(error));
  }
}

function* downloadPeriodicCycleCountProductForm(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadPeriodicCycleCountProductForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        DownloadActions.downloadPeriodicCycleCountProductForm.success()
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadPeriodicCycleCountProductForm.failed(error)
      );
    }
  } catch (error) {
    yield put(
      DownloadActions.downloadPeriodicCycleCountProductForm.failed(error)
    );
  }
}

function* downloadPeriodicCycleCountLocationForm(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadPeriodicCycleCountLocationForm,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        DownloadActions.downloadPeriodicCycleCountLocationForm.success()
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadPeriodicCycleCountLocationForm.failed(error)
      );
    }
  } catch (error) {
    yield put(
      DownloadActions.downloadPeriodicCycleCountLocationForm.failed(error)
    );
  }
}

function* downloadLocationListPeriodicCycleCount(
  action: PayloadAction<IDownloadLocationListConfirmPeriodicCycleCountRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadLocationListPeriodicCycleCount,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        DownloadActions.downloadLocationListPeriodicCycleCount.success()
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadLocationListPeriodicCycleCount.failed(
          error
        )
      );
    }
  } catch (error) {
    yield put(
      DownloadActions.downloadLocationListPeriodicCycleCount.failed(
        error
      )
    );
  }
}

function* downloadLocationListConfirmPeriodicCycleCount(
  action: PayloadAction<IDownloadLocationListConfirmPeriodicCycleCountRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadLocationListConfirmPeriodicCycleCount,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        DownloadActions.downloadLocationListConfirmPeriodicCycleCount.success()
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadLocationListConfirmPeriodicCycleCount.failed(
          error
        )
      );
    }
  } catch (error) {
    yield put(
      DownloadActions.downloadLocationListConfirmPeriodicCycleCount.failed(
        error
      )
    );
  }
}

function* downloadMaterialRequisitionReportRequest(
  action: PayloadAction<IDownloadMaterialRequisitionReportRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadMaterialRequisitionReportRequest,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        DownloadActions.downloadMaterialRequisitionReportRequest.success()
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadMaterialRequisitionReportRequest.failed(error)
      );
    }
  } catch (error) {
    yield put(
      DownloadActions.downloadMaterialRequisitionReportRequest.failed(error)
    );
  }
}

function* downloadMaterialRequisitionDetailReportRequest(
  action: PayloadAction<IDownloadMaterialRequisitionDetailReportRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadMaterialRequisitionDetailReportRequest,
      action.payload
    );
    if (result.succeeded) {
      yield put(
        DownloadActions.downloadMaterialRequisitionDetailReportRequest.success()
      );
    } else {
      const error = result as IErrorResponse;
      yield put(
        DownloadActions.downloadMaterialRequisitionDetailReportRequest.failed(
          error
        )
      );
    }
  } catch (error) {
    yield put(
      DownloadActions.downloadMaterialRequisitionDetailReportRequest.failed(
        error
      )
    );
  }
}

function* downloadReturnReport(action: PayloadAction<IDownloadReturnReport>) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadReturnReport,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadReturnReport.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadReturnReport.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadReturnReport.failed(error));
  }
}

function* downloadCartonQRCodeBank(
  action: PayloadAction<IDownloadCartonQRCodeBank>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadCartonQRCodeBank,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadCartonQRCodeBank.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadCartonQRCodeBank.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadCartonQRCodeBank.failed(error));
  }
}

function* downloadCycleCountQACollect(
  action: PayloadAction<IDownloadExcelRequest>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadCycleCountQACollect,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadCycleCountQACollect.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadCycleCountQACollect.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadCycleCountQACollect.failed(error));
  }
}

function* downloadRequestMaterialDetail(
  action: PayloadAction<IDownloadRequestMaterialDetail>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadRequestMaterialDetail,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadCycleCountQACollect.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadCycleCountQACollect.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadCycleCountQACollect.failed(error));
  }
}

function* downloadStockMoment(
  action: PayloadAction<IDownloadRequestMaterialDetail>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadStockMovement,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadCycleCountQACollect.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadCycleCountQACollect.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadCycleCountQACollect.failed(error));
  }
}

function* downloadInprocessCheck(
  action: PayloadAction<IDownloadInprocessCheck>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadInprocessCheck,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadInprocessCheck.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadInprocessCheck.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadInprocessCheck.failed(error));
  }
}

function* downloadAllInprocessCheck(
  action: PayloadAction<IDownloadAllInprocessCheck>
) {
  try {
    const result: IApiResponse<any> = yield call(
      DownloadApiService.downloadAllInprocessCheck,
      action.payload
    );
    if (result.succeeded) {
      yield put(DownloadActions.downloadAllInprocessCheck.success());
    } else {
      const error = result as IErrorResponse;
      yield put(DownloadActions.downloadAllInprocessCheck.failed(error));
    }
  } catch (error) {
    yield put(DownloadActions.downloadAllInprocessCheck.failed(error));
  }
}

export function* Watcher() {
  yield takeEvery(
    DownloadActions.downloadProductMasterData.request,
    downloadProductMasterData
  );
  yield takeEvery(
    DownloadActions.downloadWarehouseMasterData.request,
    downloadWarehouseMasterData
  );
  yield takeEvery(
    DownloadActions.downloadZoneMasterData.request,
    downloadZoneMasterData
  );
  yield takeEvery(
    DownloadActions.downloadZoneDetailMasterData.request,
    downloadZoneDetailMasterData
  );
  yield takeEvery(
    DownloadActions.downloadPalletMasterData.request,
    downloadPalletMasterData
  );
  yield takeEvery(
    DownloadActions.downloadCompanyMasterData.request,
    downloadCompanyMasterData
  );
  yield takeEvery(
    DownloadActions.downloadUserMasterData.request,
    downloadUserMasterData
  );
  yield takeEvery(
    DownloadActions.downloadProductionPlan.request,
    downloadProductionPlan
  );
  yield takeEvery(
    DownloadActions.downloadProductionPlanDetail.request,
    downloadProductionPlanDetail
  );
  yield takeEvery(
    DownloadActions.downloadProductionPlanForm.request,
    downloadProductionPlanForm
  );
  yield takeEvery(
    DownloadActions.downloadReceiveDocument.request,
    downloadReceiveDocument
  );
  yield takeEvery(
    DownloadActions.downloadReceiveDocumentById.request,
    downloadReceiveDocumentById
  );
  yield takeEvery(
    DownloadActions.downloadReceiveExportPalletLabel.request,
    downloadReceiveExportPalletLabel
  );
  yield takeEvery(
    DownloadActions.downloadReceiveForm.request,
    downloadReceiveForm
  );
  yield takeEvery(
    DownloadActions.downloadLODocument.request,
    downloadLODocument
  );
  yield takeEvery(
    DownloadActions.downloadLODocumentForm.request,
    downloadLODocumentForm
  );
  yield takeEvery(
    DownloadActions.downloadLODocumentById.request,
    downloadLODocumentById
  );
  yield takeEvery(
    DownloadActions.downloadLODeliveryProgress.request,
    downloadLODeliveryProgress
  );
  yield takeEvery(
    DownloadActions.downloadAuditTrail.request,
    downloadAuditTrail
  );
  yield takeEvery(
    DownloadActions.downloadQRCodeTracking.request,
    downloadQRCodeTracking
  );
  yield takeEvery(
    DownloadActions.downloadQRCodeBankXlsx.request,
    downloadQRCodeBankXlsx
  );
  yield takeEvery(
    DownloadActions.downloadQRCodeBankCsv.request,
    downloadQRCodeBankCsv
  );
  yield takeEvery(
    DownloadActions.downloadWarehouseReport.request,
    downloadWarehouseReport
  );
  yield takeEvery(
    DownloadActions.downloadPackingReport.request,
    downloadPackingReport
  );
  yield takeEvery(
    DownloadActions.downloadForkliftPerformanceReport.request,
    downloadForkliftPerformanceReport
  );
  yield takeEvery(
    DownloadActions.downloadDeliveryHistoryReport.request,
    downloadDeliveryHistoryReport
  );
  yield takeEvery(
    DownloadActions.downloadDeliveryHistoryForMarketingReport.request,
    downloadDeliveryHistoryForMarketingReport
  );
  yield takeEvery(
    DownloadActions.downloadInventoryComparisonForm.request,
    downloadInventoryComparisonForm
  );
  yield takeEvery(
    DownloadActions.downloadInventoryComparisonReport.request,
    downloadInventoryComparisonReport
  );
  yield takeEvery(
    DownloadActions.downloadMaterialRequisitionForm.request,
    downloadMaterialRequisitionForm
  );
  yield takeEvery(
    DownloadActions.downloadMaterialMovementForm.request,
    downloadMaterialMovementForm
  );
  yield takeEvery(
    DownloadActions.downloadPackagingMovementForm.request,
    downloadPackagingMovementForm
  );
  yield takeEvery(
    DownloadActions.downloadPeriodicCycleCountLocationForm.request,
    downloadPeriodicCycleCountLocationForm
  );
  yield takeEvery(
    DownloadActions.downloadPeriodicCycleCountProductForm.request,
    downloadPeriodicCycleCountProductForm
  );
  yield takeEvery(
    DownloadActions.downloadLocationListPeriodicCycleCount.request,
    downloadLocationListPeriodicCycleCount
  );
  yield takeEvery(
    DownloadActions.downloadLocationListConfirmPeriodicCycleCount.request,
    downloadLocationListConfirmPeriodicCycleCount
  );
  yield takeEvery(
    DownloadActions.downloadReturnReport.request,
    downloadReturnReport
  );
  yield takeEvery(
    DownloadActions.downloadMaterialRequisitionReportRequest.request,
    downloadMaterialRequisitionReportRequest
  );
  yield takeEvery(
    DownloadActions.downloadMaterialRequisitionDetailReportRequest.request,
    downloadMaterialRequisitionDetailReportRequest
  );
  yield takeEvery(
    DownloadActions.downloadCartonQRCodeBank.request,
    downloadCartonQRCodeBank
  );
  yield takeEvery(
    DownloadActions.downloadCycleCountQACollect.request,
    downloadCycleCountQACollect
  );
  yield takeEvery(
    DownloadActions.downloadENUserGuide.request,
    downloadENUserGuide
  );
  yield takeEvery(
    DownloadActions.downloadVNUserGuide.request,
    downloadVNUserGuide
  );
  yield takeEvery(
    DownloadActions.downloadRequestMaterialDetail.request,
    downloadRequestMaterialDetail
  );
  yield takeEvery(
    DownloadActions.downloadStockMovement.request,
    downloadStockMoment
  );
  yield takeEvery(
    DownloadActions.downloadInprocessCheck.request,
    downloadInprocessCheck
  );
  yield takeEvery(
    DownloadActions.downloadAllInprocessCheck.request,
    downloadAllInprocessCheck
  );
}
